import * as React from 'react';

import { maybeParseCalendarDate } from '@rematter/common/dateTime';
import { LocalizedDate } from '@rematter/ui-web';
import { ContentCard, ContentInfo, ContentSection } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as state from '../../_state/bookingDetails.state';
import { FileCard } from '../_shared/FileCard';

export const BookingTabInfo = () => {
  const { data: booking } = useAtomValue(state.$bookingDetails);

  return (
    <div className="@BookingTabInfo flex flex-col gap-5 p-5">
      <ContentCard>
        <ContentSection title="Booking Info">
          <div className="grid grid-cols-4 gap-4">
            <ContentInfo
              label="Purchase Order #"
              value={booking?.purchaseOrderNumber}
            >
              {(bookingNumber) => `PO #${bookingNumber}`}
            </ContentInfo>
            <ContentInfo label="Supplier Name" value={booking?.supplier?.name}>
              {(supplierName) => supplierName}
            </ContentInfo>
            <ContentInfo
              label="Vessel ETA Date"
              value={booking?.vesselArrivalDate}
            >
              {(vesselArrivalDate) => (
                <LocalizedDate
                  date={maybeParseCalendarDate(vesselArrivalDate)}
                  dateStyle="medium"
                />
              )}
            </ContentInfo>
            <ContentInfo label="Vessel Name" value={booking?.vesselName}>
              {(vesselName) => vesselName}
            </ContentInfo>
          </div>
        </ContentSection>
        <ContentSection title="Notes">
          <div className="grid grid-cols-2 gap-4">
            <div className="w-full max-w-[600px] text-sm">
              {booking?.externalNotes || '—'}
            </div>
          </div>
        </ContentSection>
        <ContentSection title="Attachments">
          {!!booking?.files?.length && (
            <div className="grid grid-cols-2 gap-3">
              {booking?.files?.map((file) => (
                <FileCard key={file.id} file={file} />
              ))}
            </div>
          )}
          {!booking?.files?.length && (
            <div className="flex text-sm text-neutral/40">None</div>
          )}
        </ContentSection>
      </ContentCard>
    </div>
  );
};
